// extracted by mini-css-extract-plugin
module.exports = {"qs-search_element--disabled":"_7UgYS","pagination":"_1PgPP","pagination__item":"_1Rspn","pagination__item--active":"_2UL-3","pagination__link":"_5KEU0"};